import {get, find, indexOf, size} from 'lodash';
import storeProvider from '../../store';

export const hasAccess = rolesWithAccess => {
  if (size(rolesWithAccess) === 0) {
    return true;
  }

  const store = storeProvider.getStore();
  const userInformation = get(store.getState(), 'user.userInformation', {});
  if (indexOf(rolesWithAccess, 'changeCustomer') !== -1 && userInformation.changeCustomer === true) {
    return true;
  }

  return find(rolesWithAccess, r => get(userInformation.roles, r, false)) !== undefined;
};

export const isInternalUser = () => {
  return hasAccess(['videoIntelligenceInternal']);
};

export default hasAccess;
